/* eslint-disable */
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Typography } from "@material-ui/core";
import { useStyles } from "./SubscriptionsToolbar.styles";
import { BackButton } from "../../../basf-ui";
import { messages } from "./SubscriptionsToolbar.messages";

export const SubscriptionsToolbar: React.FC = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BackButton />
      <Typography className={classes.titlePage}>
        <FormattedMessage {...messages.titlePage} />
      </Typography>
    </div>
  );
};
